'use client';

import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { Avatar, AVATAR_SIZE } from '@depop/web-ui-kit/Avatar';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { type SearchUser } from '@/modules/search/aliases';

export function UserSearchItem({ picture, username, id }: SearchUser) {
  const { sendActivityTrackerEvent } = useActivityTracker();
  const t = useTranslations('common');

  function handleClick() {
    sendActivityTrackerEvent(
      ActivityTrackerEventType.SEARCH_BAR_SELECT_USER_ACTION,
      {
        schemaVersion: '2.0',
        selectedUserId: id,
      }
    );
  }

  return (
    <li className={styles.listItem} tabIndex={-1}>
      <ExtendedLink
        className={styles.userItem}
        href={`/${username}`}
        onClick={handleClick}
        tabIndex={-1}
      >
        <span className={styles.avatarWrapper}>
          <Avatar
            className={styles.avatar}
            initials={username.charAt(0)}
            size={AVATAR_SIZE.EXTRA_SMALL}
            src={picture?.url}
          />
          <div className={styles.textContainer}>
            <Body variant="sm-regular" className={styles.username}>
              @{username}
            </Body>
            <Body variant="sm-regular" className={styles.shopText}>
              {t('Shop')}
            </Body>
          </div>
        </span>
      </ExtendedLink>
    </li>
  );
}
